import { scrollToElement } from "common/utils/ui/scroll";
import "./product-details-bulk-mobile.scss";

const $getBulkMobile = () => document.getElementById("js-bulk-mobile");
const $getBulkTable = () => document.getElementById("js-bulk-table-mobile");

const initBulkMobile = () => {
  const $bulkMobile = $getBulkMobile();
  const $bulkTable = $getBulkTable();

  $bulkMobile?.addEventListener("click", () => {
    $bulkTable?.classList?.toggle("show");
    $bulkMobile?.classList?.toggle("opened");
  });

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("t") === "pricing") {
    scrollToElement($bulkTable, true);
  }
};

export default initBulkMobile;
